import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CreditBalanceInterface } from 'features/AdsManagement/@types/apiTypes'

type PaginationStateType = {
  next_cursor: string
  prev_cursor: string
}

interface ProductAddEditStateType {
  isLoading: boolean
  principalList: CreditBalanceInterface[]
  pagination: PaginationStateType
}

const initialState: ProductAddEditStateType = {
  isLoading: false,
  principalList: [],
  pagination: { next_cursor: '', prev_cursor: '' },
}
const adsPrincipalListSlice = createSlice({
  name: 'adsPrincipalList',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setPrincipalList: (state, action: PayloadAction<CreditBalanceInterface[]>) => {
      state.principalList = action.payload
    },
    setPagination: (state, action: PayloadAction<PaginationStateType>) => {
      state.pagination = action.payload
    },
  },
})

export const { setIsLoading, setPrincipalList, setPagination } = adsPrincipalListSlice.actions

export default adsPrincipalListSlice.reducer
